export const TabSheetAction = {
    OPEN: 'open', /** Instructs the handler to open the tabSheet */
    CLOSE: 'close', /** Instructs the handler to close the tabSheet */
    RESET: 'reset' /** A neutral action. Does not affect the tab sheet. Recommended to use this after setting an action. */
}